import React from 'react';
import { FiUpload, FiArrowRight } from 'react-icons/fi';

/* A compact, non-interactive sample of the Company Seeking Funding form.
   Everything here is plain markup - no real inputs - so the whole block
   behaves as one link back to the page it depicts. The fields, the section
   bands and the submit button mirror the ones on the real page. */

const sections = [
    {
        title: 'Your Details',
        fields: ['Your Name *', 'Firm Name', 'Email ID *']
    },
    {
        title: 'Company Details',
        fields: ['Registered Name *', 'CIN', 'Website URL *', 'Amount Sought (₹Cr) *', 'Revenue (₹Cr)', 'Industry']
    }
];

const CsfPageMock = () => (
    <div className="flex min-h-0 flex-1 select-none flex-col bg-white px-3.5 py-3 text-left">
        {sections.map(section => (
            <div key={section.title} className="mb-3">
                <div className="rounded-r-[4px] border-l-[3px] border-[#BC8B20] bg-[#FDF7E9] px-2.5 py-[5px]">
                    <span className="font-sans_medium_body text-[10px] font-semibold leading-[13px] text-[#8a6516]">
                        {section.title}
                    </span>
                </div>
                <div className="mt-2 grid grid-cols-3 gap-x-2.5 gap-y-2">
                    {section.fields.map(label => (
                        <div key={label}>
                            <span className="block truncate font-sans_book_body text-[9px] leading-[12px] text-[#374151]">
                                {label}
                            </span>
                            <div className="mt-1 h-[24px] rounded-[4px] border border-[#D1D5DB] bg-white" />
                        </div>
                    ))}
                </div>
            </div>
        ))}

        <div>
            <span className="block font-sans_book_body text-[9px] leading-[12px] text-[#374151]">
                Pitch Deck *
            </span>
            <div className="mt-1 flex items-center space-x-2">
                <span className="flex items-center space-x-1 rounded-[4px] border border-[#D1D5DB] bg-white px-2 py-[4px]">
                    <FiUpload className="text-[#374151]" size={10} />
                    <span className="font-sans_book_body text-[9px] leading-[12px] text-[#374151]">Choose File</span>
                </span>
                <span className="font-sans_book_body text-[9px] leading-[12px] text-[#9CA3AF]">No file chosen</span>
            </div>
            <p className="mt-1 font-sans_book_body text-[8px] leading-[11px] text-[#9CA3AF]">
                Note: The file size must not exceed 10MB.
            </p>
        </div>

        {/* Same gold submit button the real form ends with. */}
        <div className="mt-auto flex justify-center pt-3">
            <span className="inline-flex items-center rounded-[4px] bg-[#BC8B20] px-4 py-[6px] font-sans_medium_body text-[10px] leading-[13px] text-white shadow-sm">
                Submit
                <FiArrowRight className="ml-1" size={11} />
            </span>
        </div>
    </div>
);

export default CsfPageMock;
